import { apiStatusCodes } from "../config/global-variables";
import getRequestURL from '../utils/getRequestURL';

let refreshPromise = null;

/**
 * Avoided the use of model base to make requests here as I want to avoid cross dependency on the modules
 */
function refreshToken() {
    const accessTokenExpiredException = new Error('Login required');
    accessTokenExpiredException.code = apiStatusCodes.unauthorized;

    const requestParam = {
        url: getRequestURL('/api/account/refresh/web'),
        method: 'POST',
        withCredentials: true
    };

    return m.request(requestParam)
        .then((result) => {
            if (result.data != null && result.transResult[0].transStatus == 'SUCCESS') {
                // loginModel.setToken(result.data.token, result.data.refreshToken);
            } else {
                throw accessTokenExpiredException;
            }
        })
        .catch((error) => {
            // Refresh token has timed out — handle both 400 and 401
            if (error.code === apiStatusCodes.badRequest || error.code === apiStatusCodes.unauthorized) {
                throw accessTokenExpiredException;
            }
            throw error;
        })
        .finally(() => {
            refreshPromise = null;
        });
}


/**
 * Temporary measure to sync up both model bases so that it won't attempt to refresh twice
 * 
 * @author Darrus Goh
 */
const RefreshService = {
    refresh: () => {
        // Refresh was not called
        if (!refreshPromise)
            refreshPromise = refreshToken();

        return refreshPromise;
    }
};

export default RefreshService;